/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prefer-const */
/* eslint-disable react/destructuring-assignment */
import {
  CloseCircleFilled,
  FilePdfOutlined,
  PhoneOutlined,
  PlusOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Alert,
  Badge,
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  Modal,
  Popover,
  Select,
  Skeleton,
  Spin,
  TimePicker,
  Tooltip,
  message,
} from "antd";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetAppointmentFilters } from "../../../redux/slices/appointmentSlice";
import {
  CREATE_SCHEDULED_EMAIL,
  CREATE_SCHEDULED_MESSAGE,
  SAVE_AS_DRAFT,
  UPDATE_SCHEDULED_EMAIL,
} from "../../../graphql/mutation";
import {
  GET_ENGAGEMENT_MESSAGE_TEMPLATES,
  GET_ENGAGEMENT_TEMPLATE_TEXT,
  GET_INITIAL_REVIEW_MESSAGE,
  GET_SCHEDULED_EMAILS_FOR_LEAD,
} from "../../../graphql/query";
import { resolveLeadOpportunityId } from "../../../helpers/opportunityHelper";
import useDebounce from "../../../hooks/debounceHook";
import useLang from "../../../hooks/useLang";
import AppointmentIcon from "../../../icons/js/AppointmentIcon";
import AttachmentIcon from "../../../icons/js/AttachmentIcon";
import { BottomCalendarIcon } from "../../../icons/js/CalendarIcon";
import CarIcon from "../../../icons/js/CarIcon";
import DeleteIcon from "../../../icons/js/DeleteIcon";
import { CodeBrackets, EmailWithSearch, SignatureIcon } from "../../../icons/js/EmailIcons";
import GIFIcon from "../../../icons/js/GIFIcon";
import NotesIcon from "../../../icons/js/NotesIcon";
import OttoLinkIcon from "../../../icons/js/OttoLinkIcon";
import { EditPencilIcon } from "../../../icons/js/PencilIcon";
import { PhoneIconJSX } from "../../../icons/js/PhoneIconJSX";
import { RemainderIcon21 } from "../../../icons/js/RemainderIcon";
import ReviewTemplateIcon from "../../../icons/js/ReviewTemplateIcon";
import SendIcon from "../../../icons/js/SendIcon";
import SmilyIconJSX from "../../../icons/js/SmilyIcon";
import TemplateIcon from "../../../icons/js/TemplateIcon";
import { AccessPermissionAction, timezones } from "../../../library/constants";
import { checkAccessPermission, openDialog } from "../../../library/helpers";
import {
  addScheduledMessage,
  getLatestMessageLeadOpportunityId,
} from "../../../redux/slices/leadSlice";
import { makeVoiceCall } from "../../../utils";
import { handleMediaEvent } from "./engagementActivity";
import { APPOINTMENT_LINK_TEMPLATE, buildLinkedContentFragment } from "./engagementHelpers";
import EmojiPicker from "./mediaSharing/emojiPicker";
import GifPickerComponent from "./mediaSharing/gifPicker";
import MmsMediaButtons from "./mmsMediaButtons";
import ScheduleMessagesPopup from "./scheduleMessagesPopup";
import { ScheduledJSX } from "./Emails";
import { TEMPLATE_ENUMS } from "../../../constant/EmailConstant";
import { TEMPLATE_LIST_PAGE_SIZE } from "../../../constant/TemplateConstant";
import { buildTemplateQueryVariables, getTemplateList } from "../../../helpers/templateHelpers";
import VehicleDetailPage from "./VDP/VehicleDetailPage";
import OttoVinPanel from "./OttoVin/OttoVinPanel";

export function BottomActions({
  handleFiles,
  fetchData,
  setMediaUploadLoader,
  handleMMS,
  emailForm,
  onlyFirstMessage,
  onClickHandler,
  tooltipTitle,
  afterMessageConsent,
  setCallConsentMessage,
  sendConsentMessage,
  isConsentStatusEnable,
  attachments,
  handleMediaSharing,
  mediaRef,
  videoRef,
  documentRef,
  setAttachments,
  text,
  selectedLead,
  user,
  setTemplateModal,
  showReviewRequestButton = true,
  setmessageText,
  setisReview,
  activeOppName,
  textMode,
  messageText,
  handleSetDefinedTemplate,
  handleAddAppointment,
  scheduledMessages,
  getMessages,
  setrichTextValue,
  richTextValue,
  buttonDisabled,
  messageLoader,
  loading,
  spinner,
  leadsLoading,
  mmsLoader,
  buttonStyle,
  setmmsLoader,
  setSummaryVisible,
  summaryVisible,
  setscheduledMessageDrawer,
  crmIntegrationType,
  opportunityList,
  addSignature,
  emailCursor,
  emailTextRef,
  selectedOppTypeId,
}) {
  const [lang] = useLang();
  const [loaderFn, setloaderFn] = useState(false);
  const [mediaProcessingLoader, setMediaProcessingLoader] = useState(false);
  const [selectedScheduleEmail, setselectedScheduleEmail] = useState(null);
  const [scheduleMessageForm, setscheduleMessageForm] = useState({
    open: false,
    textMode: "Message",
    mode: "ADD",
  });
  const [vdpDrawerOpen, setVdpDrawerOpen] = useState(false);
  const [ottoVinDrawerOpen, setOttoVinDrawerOpen] = useState(false);
  const { textMode: textModeRedux, messageOpportunity } = useSelector(state => state.lead);
  const { email } = useSelector(state => state.user);
  const popoverRef = useRef(null);
  const schedulePopupRef = useRef();
  const dispatch = useDispatch();
  const [getMessageText, { loading: appointmentLinkLoading }] = useLazyQuery(
    GET_ENGAGEMENT_TEMPLATE_TEXT,
    {
      fetchPolicy: "cache-first",
    }
  );
  const [createScheduledMessage, { loading: createScheduledMessageLoader }] =
    useMutation(CREATE_SCHEDULED_MESSAGE);
  const canShareVDP = checkAccessPermission(AccessPermissionAction.VDP_FEATURE_VIEW);
  // OttoVin: gated on the SEND action of OTTOVIN_MANAGEMENT (backend-seeded;
  // platform admins bypass via checkAccessPermission).
  const canSendOttoVin = checkAccessPermission(AccessPermissionAction.OTTOVIN_SEND);

  const canSendEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_SEND);

  const canAudioCall = checkAccessPermission(AccessPermissionAction.CALL_MANAGEMENT_AUDIO);
  const canVideoCall = checkAccessPermission(AccessPermissionAction.CALL_MANAGEMENT_VIDEO);

  const handleInsertLink = urlString => {
    const editor = document.getElementById("rich-text");
    editor.focus(); // Ensure editor is focused

    if (!emailCursor) return; // If no cursor position saved, do nothing

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(emailCursor); // Restore cursor position

    // Each line is either a bare URL or a label followed by a URL (the VDP and
    // appointment formats) — only the URL is hyperlinked.
    const range = selection.getRangeAt(0);
    range.deleteContents(); // Remove any selected text
    range.insertNode(buildLinkedContentFragment(urlString));

    // Move cursor after the inserted content
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
  };

  const handleInsertSnippet = snippet => {
    const editor = document.getElementById("rich-text");
    editor.focus(); // Ensure editor is focused

    if (!emailCursor) return; // If no cursor position saved, do nothing

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(emailCursor); // Restore cursor position

    // Insert snippet at restored cursor position
    const range = selection.getRangeAt(0);
    range.deleteContents(); // Remove any selected text

    const snippetNode = document.createTextNode(snippet);
    range.insertNode(snippetNode);

    // Move cursor after snippet
    range.setStartAfter(snippetNode);
    range.setEndAfter(snippetNode);
    selection.removeAllRanges();
    selection.addRange(range);
  };
  const handleSendAppointmentLink = async () => {
    const existingText = text.current.value;
    // Append the appointment placeholder with exactly one separating space so
    // it never concatenates with (or doubles the space after) existing text.
    // The label travels with the placeholder so the BE expands the URL in
    // place and the recipient gets "Schedule appointment here: <short url>".
    const requestContent = existingText
      ? `${existingText.replace(/\s+$/, "")} ${APPOINTMENT_LINK_TEMPLATE}`
      : APPOINTMENT_LINK_TEMPLATE;
    // Opp-scope hints for the {createAppointmentUrl} expansion. Priority
    // matches what the user requested: when a specific opp is picked
    // in the thread dropdown, send leadOpportunityId so the link pins
    // exactly to that opp; otherwise when only an opp-type tab is
    // active (e.g. "All Sales"), send oppTypeId (the root id) so the
    // BE resolves to the most-recent active opp of that type. When
    // neither is set, both stay null and the BE falls back to the
    // legacy "most-recently-updated active opp" behavior.
    const resolvedLeadOppId = resolveLeadOpportunityId(messageOpportunity);
    const res = await getMessageText({
      variables: {
        leadId: selectedLead.id,
        content: requestContent,
        leadOpportunityId: resolvedLeadOppId || null,
        oppTypeId: resolvedLeadOppId ? null : selectedOppTypeId || null,
      },
    });
    if (res.data.getEngagementTemplateText.statusCode === 200) {
      const { content } = res.data.getEngagementTemplateText;
      if (textModeRedux === "Email") {
        handleInsertLink(content || "");
      } else {
        text.current.value = content;
        text.current.style.height = `${text.current.scrollHeight}px`;
        setmessageText(content);
      }
    } else {
      message.error(res.data.getEngagementTemplateText.message);
    }
  };
  const Attachments = () => {
    return (
      <div className="flex flex-col justify-center  gap-5">
        {!attachments.some(file => file?.file?.type?.includes("gif") || false) && (
          <MmsMediaButtons
            color="#64748B"
            handleMediaSharing={handleMediaSharing}
            mediaRef={mediaRef}
            videoRef={videoRef}
            documentRef={documentRef}
            handleMediaEvent={e =>
              handleMediaEvent(e, attachments, setAttachments, setMediaProcessingLoader)
            }
            mediaProcessingLoader={mediaProcessingLoader}
          />
        )}{" "}
        {attachments.length === 0 && (
          <div key="gifPicker" className="icon-wrapper">
            <Popover
              showArrow={false}
              content={
                <div onClick={e => e.stopPropagation()}>
                  <GifPickerComponent
                    attachments={attachments}
                    setAttachments={setAttachments}
                    selectedLead={selectedLead}
                    user={user}
                  />
                </div>
              }
              trigger="click"
              destroyTooltipOnHide
            >
              <span className="flex items-center justify-start cursor-pointer">
                <GIFIcon className="text-[20px] mr-1.5" />
                Select GIF
              </span>
            </Popover>
          </div>
        )}{" "}
      </div>
    );
  };
  const [getReviewMessage, { loading: reviewInviteLoading }] = useLazyQuery(
    GET_INITIAL_REVIEW_MESSAGE,
    {
      fetchPolicy: "network-only",
    }
  );

  const latestMessageLeadOpportunityId = useSelector(getLatestMessageLeadOpportunityId);

  const handleReviewInvite = async () => {
    const res = await getReviewMessage({
      variables: {
        leadId: selectedLead.id,
        leadOpportunityId: resolveLeadOpportunityId(
          messageOpportunity,
          latestMessageLeadOpportunityId
        ),
      },
    });
    if (res?.data?.getInitialReviewMessage?.statusCode === 200) {
      const content = res?.data?.getInitialReviewMessage?.content;
      if (textModeRedux === "Email") {
        handleInsertSnippet(content);
      } else {
        text.current.value = content;
        text.current.style.height = `${text.current.scrollHeight}px`;
        setmessageText(content);
      }
      setisReview(true);
    } else {
      message.error("Failed to generate review message. Please contact support.");
    }
  };

  const handleVoiceCall = async () => {
    if (!selectedLead?.id || !user?.id) {
      message.error("Missing lead or user information");
      return;
    }

    const currentLocationId = sessionStorage.getItem("currentLocationId");
    const locationId = currentLocationId?.includes(",")
      ? currentLocationId.split(",")[0]
      : currentLocationId;

    if (!locationId) {
      message.error("Missing location information");
      return;
    }

    await makeVoiceCall({
      location_id: locationId,
      user_id: user.id.toString(),
      lead_id: selectedLead.id.toString(),
    });
  };

  const OttoLinks = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        {crmIntegrationType === "EL" && (
          <span
            onClick={() => {
              openDialog("documentSelector", {
                width: "620px",
                dialogHeader: "Print Dealer Documents",
                leadId: selectedLead?.id,
                activeOppName: activeOppName,
                opportunityList: opportunityList,
              });
            }}
            className="flex items-center justify-start cursor-pointer"
          >
            <FilePdfOutlined className="text-[20px] mr-1.5" />
            Print Dealer Document
          </span>
        )}

        <span
          onClick={() => handleSendAppointmentLink()}
          className="flex items-center justify-start cursor-pointer"
        >
          <BottomCalendarIcon className="text-[20px] mr-1.5" />
          Attach Appointment Link
        </span>
        {showReviewRequestButton && (
          <span
            onClick={() => handleReviewInvite()}
            className="flex items-center justify-start cursor-pointer"
          >
            <ReviewTemplateIcon className="text-[20px] mr-1.5" />
            Review Invite
          </span>
        )}
        {textModeRedux === "Text" && (
          <span
            onClick={() => setTemplateModal({ visible: true })}
            className="flex items-center justify-start cursor-pointer"
          >
            <TemplateIcon className="text-[20px] mr-1.5" />
            Select Template
          </span>
        )}
        {canShareVDP && (
          <span
            onClick={() => setVdpDrawerOpen(true)}
            className="flex items-center justify-start cursor-pointer"
          >
            <CarIcon color="#64748B" className="text-[20px] mr-1.5" />
            VDP
          </span>
        )}
        {canSendOttoVin && selectedLead?.id && (
          <span
            onClick={() => setOttoVinDrawerOpen(true)}
            className="flex items-center justify-start cursor-pointer"
          >
            <CarIcon color="#64748B" className="text-[20px] mr-1.5" />
            OttoVin
          </span>
        )}
      </div>
    );
  };
  const CallLinks = ({ permission }) => {
    return (
      <div className="flex flex-col justify-center gap-5">
        <span
          className={`flex items-center justify-start cursor-pointer ${
            !permission.canAudioCall ? "opacity-50 pointer-events-none" : ""
          }`}
          onClick={permission.canAudioCall ? handleVoiceCall : undefined}
        >
          <PhoneOutlined className="text-[20px] rotate-90 mr-1.5" />
          Voice Call
        </span>
        <span
          className={`flex items-center justify-start cursor-pointer ${
            !permission.canVideoCall ? "opacity-50 pointer-events-none" : ""
          }`}
          // Add your onClick handler here if needed
        >
          <VideoCameraOutlined className="text-[20px] mr-1.5" />
          Video Call
        </span>
      </div>
    );
  };

  const Signature = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        <span
          // onClick={() => handleSendReviewClick()}
          onClick={() =>
            openDialog("emailSignature", {
              dialogHeader: "Email Signature",
              width: "700px",
              mode: "EDIT",
              addSignature,
            })
          }
          className="flex items-center justify-start cursor-pointer"
        >
          <EditPencilIcon color="#334155" className="text-[20px] mr-1.5" />
          Edit Signature
        </span>
        <span
          onClick={() =>
            openDialog("emailSignature", {
              dialogHeader: "Email Signature",
              width: "700px",
              mode: "ADD",
              addSignature,
            })
          }
          className="flex items-center justify-start cursor-pointer"
        >
          <PlusOutlined className="text-[20px] mr-1.5" />
          Insert Signature
        </span>
      </div>
    );
  };
  const InsertFields = () => {
    const [search, setsearch] = useState("");
    const arr = [
      "{dealerName}",
      "{companyName}",
      "{leadOwner}",
      "{userFullName}",
      "{userName}",
      "{userFirstName}",
      "{userLastName}",
      "{fullName}",
      "{firstName}",
      "{lastName}",
      "{leadFullName}",
      "{leadFirstName}",
      "{leadLastName}",
      "{sourceName}",
      "{previousVehicle}",
      "{currentVehicle}",
      "{vehicleOfInterest}",
      "{primaryVehicle}",
      "{locationName}",
      "{locationAddress}",
      "{locationUrl}",
      "{createAppointmentUrl}",
    ];
    return (
      <div>
        <Input
          onChange={e => setsearch(e.target.value)}
          onClick={e => e.stopPropagation()}
          placeholder="Search snippets"
        />
        <div className="flex-col-centered gap-2 overflow-y-auto h-[200px]">
          {arr
            .filter(item =>
              isEmpty(search) ? item : item.toLowerCase().includes(search.toLowerCase())
            )
            .map((item, index) => (
              <span
                onClick={e => {
                  e.stopPropagation();
                  handleInsertSnippet(item);
                }}
                className="cursor-pointer"
                key={index}
              >
                {item}
              </span>
            ))}
        </div>
      </div>
    );
  };
  const EmailTemplate = () => {
    const [lang] = useLang();
    const [emailTemplates, setemailTemplates] = useState([]);
    const [search, setsearch] = useState("");
    const { loading: emailTemplateLoader } = useQuery(GET_ENGAGEMENT_MESSAGE_TEMPLATES, {
      variables: buildTemplateQueryVariables({
        scope: null,
        companyId: user.company.id,
        userId: user.id,
        templateType: TEMPLATE_ENUMS.EMAIL,
        isActive: true,
        search, // Pass search term to the query
        pageSize: TEMPLATE_LIST_PAGE_SIZE,
      }),
      onCompleted: res => {
        setemailTemplates(getTemplateList(res));
      },
    });
    const [getEngagementTemplateText] = useLazyQuery(GET_ENGAGEMENT_TEMPLATE_TEXT);
    const parseTemplate = async template => {
      const payload = {
        content: template?.message,
        leadId: selectedLead.id,
      };
      const res = await getEngagementTemplateText({
        variables: payload,
      });
      emailTextRef.current.innerHTML = res?.data?.getEngagementTemplateText?.content;
      emailForm.setFieldValue("subject", template?.subject);
    };
    return (
      <div className="p-2">
        <Input
          onClick={e => e.stopPropagation()}
          placeholder={lang?.searchTemplate}
          disabled={isEmpty(emailTemplates)}
          onChange={e => setsearch(e.target.value)}
        />
        <div className="flex-col-centered gap-1 mt-1">
          <Skeleton loading={emailTemplateLoader} active paragraph={{ rows: 4 }}>
            {!isEmpty(emailTemplates) ? (
              emailTemplates?.map((option, index) => (
                <span
                  key={index}
                  onClick={e => {
                    // e.stopPropagation();
                    parseTemplate(option);
                  }}
                  className="p-1 cursor-pointer"
                >
                  {option.title || ""}
                </span>
              ))
            ) : (
              <p className="text-gray-500 m-0 mt-1">{lang?.noTemplates}</p>
            )}
          </Skeleton>
        </div>
      </div>
    );
  };
  const OptoutErrorMessage = "Lead has opted out, you cannot message this lead now!";
  const ErrorPopover = <Alert type="error" showIcon message={OptoutErrorMessage} />;

  const bottomActions = [
    {
      render: (
        <EmojiPicker
          key={`emjoi_picker_${selectedLead?.id}`}
          textMode={textMode}
          handleSetDefinedTemplate={handleSetDefinedTemplate}
          text={text}
          messageText={messageText}
          emailCursor={emailCursor}
          emailTextRef={emailTextRef}
        />
      ),
      title: "Emoji",
      icon: <SmilyIconJSX color="black" />,
      autoCloseDisabled: true,
    },
    {
      render: <Attachments />,
      icon: <AttachmentIcon color="black" />,
      title: "Attach File",
    },
    {
      render: <OttoLinks />,
      icon: <OttoLinkIcon color="black" />,
      title: "Otto Links",
    },
    ...(textModeRedux === "Text"
      ? [
          {
            render: <CallLinks permission={{ canAudioCall, canVideoCall }} />,
            icon: <PhoneIconJSX color="black" />,
            title: "Audio & video call",
          },
          {
            render: null,
            icon: (
              <AppointmentIcon
                color="black"
                onClick={e => {
                  if (buttonDisabled()) {
                    message.error(OptoutErrorMessage);
                    return;
                  }
                  // Reset Opp Type / Opp Status filters and re-apply default
                  // "all statuses" for appointments before opening the drawer,
                  // mirroring the signout reset.
                  dispatch(resetAppointmentFilters());
                  handleAddAppointment(e);
                }}
                showBG
                bgColor="#E2E8F0"
              />
            ),
            title: "Add Appointment",
          },
          {
            icon: <div className="h-[20px] w-[2px] bg-gray-500" />,
            hover: false,
          },
          {
            icon: (
              <span className="flex-row-centered gap-1 items-center">
                <NotesIcon
                  onClick={() =>
                    setSummaryVisible(prev => ({
                      visible: true,
                      count: prev.count + 1,
                    }))
                  }
                />
                {summaryVisible.visible && (
                  <CloseCircleFilled
                    className="text-[#64748B] cursor-pointer"
                    onClick={() => setSummaryVisible({ visible: false, count: 0 })}
                  />
                )}
              </span>
            ),
            render: null,
            title: "Conversation summary",
          },
        ]
      : canSendEmail
      ? [
          // {
          //   icon: <SignatureIcon />,
          //   render: <Signature />,
          //   title: "Add Signature",
          // },
          {
            icon: <div className="h-[20px] w-[2px] bg-gray-500" />,
            hover: false,
          },
          {
            icon: (
              <span className="flex-row-centered items-center gap-[7px]">
                <EmailWithSearch />
                <span className="text-grey-700 font-[400]">Use Template</span>
              </span>
            ),
            render: <EmailTemplate />,
            title: "Use Template",
          },
          {
            icon: (
              <span className="flex-row-centered items-center gap-[7px]">
                <CodeBrackets />
                <span className="text-grey-700 font-[400]">Insert Fields</span>
              </span>
            ),
            title: "Insert Fields",
            render: <InsertFields />,
          },
        ]
      : []),
  ];
  const [createScheduledEmail] = useMutation(CREATE_SCHEDULED_EMAIL);
  const [updateScheduledEmail] = useMutation(UPDATE_SCHEDULED_EMAIL);
  const handleQuickSchedule = async (date, mode) => {
    try {
      const isEmail = mode === "Email";
      // console.log("handleQuickSchedule => Called");
      if (isEmail) {
        if (emailForm.getFieldValue("subject") === "" || emailTextRef.current.innerHTML === "") {
          return message.error("Please enter the subject and body of the email");
        }
        // console.log("handleQuickSchedule:attachments", attachments);
        let mmsArr = [];
        if (attachments.length > 0) {
          mmsArr = await handleFiles(
            attachments.filter(file => file.mediaUrl.includes("localhost")),
            user,
            selectedLead,
            fetchData,
            setMediaUploadLoader
          );
        }
        const payload = {
          subject: emailForm.getFieldValue("subject"),
          body: emailTextRef.current.innerHTML,
          leadId: selectedLead.id,
          to: emailForm.getFieldValue("to"),
          scheduledDate: date,
          timezone: dayjs.tz.guess(),
          id: selectedScheduleEmail?.id,
          attachments: [
            ...mmsArr,
            ...attachments.filter(file => !file.mediaUrl.includes("localhost")),
          ],
        };
        if (selectedScheduleEmail?.id) {
          const scheduleEmailRes = await updateScheduledEmail({
            variables: payload,
          });
          if (scheduleEmailRes.data.updateScheduledEmail.statusCode === 200) {
            message.success(scheduleEmailRes.data.updateScheduledEmail.message);
            emailForm.resetFields();
            emailTextRef.current.innerHTML = "";
            setselectedScheduleEmail(null);
            getMessages();
            return true;
          }
          message.error(scheduleEmailRes.data.updateScheduledEmail.message);
          return false;
        }
        const scheduleEmailRes = await createScheduledEmail({
          variables: payload,
        });
        if (scheduleEmailRes.data.createScheduledEmail.statusCode === 200) {
          message.success(scheduleEmailRes.data.createScheduledEmail.message);
          emailForm.resetFields();
          emailTextRef.current.innerHTML = "";
          setselectedScheduleEmail(null);
          getMessages();
          return true;
        }
        message.error(scheduleEmailRes.data.createScheduledEmail.message);
        return false;
      }
      if (text.current.value === "") {
        return message.error("Please enter a message first");
      }
      const obj = {
        leadId: selectedLead?.id,
        message: text.current.value,
        scheduledDate: date,
        timezone: dayjs.tz.guess(),
      };
      const res = await createScheduledMessage({
        variables: { ...obj },
      });
      if (res.data.createScheduledMessage.statusCode === 200) {
        text.current.value = "";
        text.current.style.height = "0px";
        setmessageText("");
        const newScheduledMessage = res.data.createScheduledMessage.scheduledMessage;
        dispatch(addScheduledMessage(newScheduledMessage));
        message.success(res.data.createScheduledMessage.message);
        // Refetch messages from page 1 to show the scheduled message at the top
        getMessages({
          variables: {
            leadId: selectedLead?.id,
            page: 1,
          },
        });
      } else {
        message.error(res.data.createScheduledMessage.message);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const [scheduledEmails, setscheduledEmails] = useState([]);
  const [scheduleEmailDrawer, setscheduleEmailDrawer] = useState({
    visible: false,
    emails: [],
  });
  const { refetch: refetchScheduledEmailsForLead } = useQuery(GET_SCHEDULED_EMAILS_FOR_LEAD, {
    variables: {
      leadId: selectedLead.id,
    },
    skip: !selectedLead?.id,
    onCompleted: res => {
      setscheduledEmails(res.getScheduledEmailsForLead);
    },
  });
  const refetchScheduledEmailsForLeadHandler = async () => {
    const res = await refetchScheduledEmailsForLead();
    if (res.data.getScheduledEmailsForLead) {
      setscheduledEmails(res.data.getScheduledEmailsForLead);
    }
  };
  const sendMenu = mode => {
    const isEmail = mode === "Email";
    const close = () => schedulePopupRef.current.click();
    return (
      <div className="flex flex-col items-start gap-2" onClick={e => e.stopPropagation()}>
        <span className="text-sm text-[#64748B] font-[400] ">Schedule {mode}</span>
        <span
          onClick={() => {
            if (isEmail) {
              if (
                emailForm.getFieldValue("subject") === "" ||
                emailTextRef.current.innerHTML === ""
              ) {
                return message.error("Please enter the subject and body of the email");
              }
              setscheduleMessageForm({ open: true, textMode: mode, mode: "ADD" });
              close();
            } else {
              if (text.current.value === "") return message.error("Please enter a message first");
              setscheduleMessageForm({ open: true, textMode: mode, mode: "ADD" });
              close();
            }
          }}
          className="text-[16px] font-[400] text-grey-700 cursor-pointer"
        >
          Select custom date & time
        </span>
        {isEmail
          ? scheduledEmails.length > 0 && (
              <>
                <div className="h-[1px] w-full bg-[#CBD5E1]" />
                <span
                  className="cursor-pointer text-[16px] font-[500] text-brand-500"
                  onClick={() => {
                    // setscheduledMessageDrawer({ open: true, messages: scheduledMessages });
                    setscheduleEmailDrawer({ visible: true, emails: scheduledEmails });
                    close();
                  }}
                >
                  Scheduled Emails ({scheduledEmails.length})
                </span>
              </>
            )
          : scheduledMessages.length > 0 && (
              <>
                <div className="h-[1px] w-full bg-[#CBD5E1]" />
                <span
                  className="cursor-pointer text-[16px] font-[500] text-brand-500"
                  onClick={() => {
                    setscheduledMessageDrawer({ open: true, messages: scheduledMessages });
                    close();
                  }}
                >
                  Scheduled Messages ({scheduledMessages.length})
                </span>
              </>
            )}
      </div>
    );
  };
  const hasConsent = isConsentStatusEnable(
    selectedLead?.textConsentStatus,
    user?.company?.isOptinConsentMethod
  );
  const consent = useMemo(() => selectedLead?.textConsentStatus, [selectedLead]);
  const { selectedEmail } = useSelector(state => state.lead);
  const [saveAsDraft, { loading: saveAsDraftLoader }] = useMutation(SAVE_AS_DRAFT);
  const [draftSaved, setdraftSaved] = useState(false);

  const saveDraft = async () => {
    // console.log("========== saveDraft", email);
    if (email.email !== "" && email.subject !== "") {
      try {
        await saveAsDraft({
          variables: {
            draftType: "EMAIL",
            leadId: selectedLead.id,
            companyId: user.company.id,
            locationId: sessionStorage.getItem("currentLocationId")?.includes(",")
              ? null
              : sessionStorage.getItem("currentLocationId"),
            userId: user.id,
            body: email.body,
            subject: email.subject,
            receiver: email.email,
          },
        });
        setdraftSaved(true);
      } catch (error) {
        console.error("Error saving draft:", error);
      }
    }
  };

  // Create debounced version of your function (800ms delay)
  const debouncedSaveDraft = useDebounce(saveDraft, 2 * 1000, [email]);

  useEffect(() => {
    // console.log("========== email", email);
    debouncedSaveDraft();
  }, [email]);

  return (
    <Spin
      spinning={reviewInviteLoading || appointmentLinkLoading || mmsLoader}
      tip={mmsLoader ? "Uploading media..." : undefined}
    >
      <div className="flex-row-centered justify-between w-full p-2">
        <div className="flex-row-centered gap-2 items-center">
          {hasConsent &&
            bottomActions.map((item, index) => {
              const actionProps = {
                buttonDisabled,
                ErrorPopover,
                item,
                hover: item.hover ?? true,
                index,
              };
              return <Actions key={index} {...actionProps} />;
            })}
        </div>
        <div className="flex-row-centered gap-3 items-center">
          {draftSaved && textModeRedux !== "Text" && (
            <span className="italic text-grey-100 flex-row-centered gap-1">
              {saveAsDraftLoader ? "Saving Draft..." : "Draft Saved"}
            </span>
          )}
          {hasConsent && (
            <Tooltip title={textModeRedux === "Text" ? "Schedule message" : "Schedule an email"}>
              <Popover
                trigger={["click"]}
                content={
                  buttonDisabled()
                    ? ErrorPopover
                    : textModeRedux === "Text"
                    ? sendMenu("Message")
                    : sendMenu("Email")
                }
              >
                <Badge
                  className="testing"
                  count={
                    textModeRedux === "Text" ? scheduledMessages.length : scheduledEmails.length
                  }
                  size="small"
                >
                  <span
                    className="px-1 flex-row-centered justify-center cursor-pointer hover:bg-[#E2E8F0] rounded-[4px] p-1"
                    type="text"
                    ref={schedulePopupRef}
                  >
                    <RemainderIcon21 color="black" />
                  </span>
                </Badge>
              </Popover>
            </Tooltip>
          )}
          <Tooltip title={tooltipTitle()}>
            <Button
              className="flex-row-centered gap-1 text-white items-center rounded-[4px]"
              type="primary"
              key={`attach_btn_${selectedLead?.id}`}
              onClick={async () => {
                if (text?.current?.dataset?.aiGenerating === "true") {
                  return message.info("Please wait while AI response is being generated");
                }
                if (mmsLoader) {
                  return message.info("Please wait while we complete the current process");
                }
                let mmsArr = [];
                if (attachments.length > 0 && textModeRedux !== "Email") {
                  setmmsLoader(true);
                  mmsArr = await handleFiles(
                    attachments,
                    user,
                    selectedLead,
                    fetchData,
                    setMediaUploadLoader
                  );
                }
                if (textModeRedux === "Email") {
                  return emailForm.submit();
                }
                if (mmsArr && mmsArr?.length > 0) {
                  return handleMMS(mmsArr);
                }
                if (textModeRedux === "Text") {
                  if (
                    isConsentStatusEnable(
                      selectedLead?.textConsentStatus,
                      user?.company?.isOptinConsentMethod
                    )
                  ) {
                    if (
                      isEmpty(messageText.trim()) &&
                      isEmpty(textMode === 0 ? text.current.value : richTextValue)
                    ) {
                      return message.error(lang.pleaseEnterMessageToSend);
                    }
                    setmessageText(textMode === 0 ? text.current.value : richTextValue);
                    const rawText = (text.current?.value || "").trim();
                    const richText = (richTextValue || "").trim();
                    const bodyText = textMode === 0 ? rawText : richText;
                    let msg;
                    if (onlyFirstMessage) {
                      if (selectedLead?.messages?.length > 0) {
                        msg = bodyText || (messageText || "").trim();
                      } else {
                        msg =
                          afterMessageConsent !== ""
                            ? `${bodyText} ${afterMessageConsent}`
                            : bodyText;
                      }
                    } else {
                      msg =
                        afterMessageConsent !== ""
                          ? `${bodyText} ${afterMessageConsent}`
                          : bodyText;
                    }
                    // Clear textarea immediately so the user sees the send
                    // is in flight — matches handleKeyUp Enter-send flow.
                    if (text.current) {
                      text.current.value = "";
                      text.current.style.height = "inherit";
                    }
                    setmessageText("");
                    if (textMode !== 0) {
                      setrichTextValue("");
                    }
                    onClickHandler(msg, selectedLead, user?.id);
                  } else {
                    setCallConsentMessage(true);
                    sendConsentMessage();
                  }
                }
              }}
              style={{ ...buttonStyle(), padding: "5px" }}
              loading={messageLoader || loaderFn || mmsLoader}
              disabled={
                buttonDisabled() ||
                !selectedLead?.id ||
                messageLoader ||
                loading ||
                spinner ||
                leadsLoading ||
                textMode !== 0 ||
                loaderFn ||
                mmsLoader ||
                (textModeRedux === "Email" && !selectedEmail?.email)
              }
            >
              Send <SendIcon color="white" />
            </Button>
          </Tooltip>
        </div>
        <Modal
          footer={null}
          className="normal-popup"
          onCancel={() => setscheduleMessageForm({ open: false })}
          title={`Schedule ${scheduleMessageForm.textMode}`}
          open={scheduleMessageForm.open}
        >
          {scheduleMessageForm.textMode === "Email" ? (
            <EmailSchedule
              popoverRef={schedulePopupRef}
              emailForm={emailForm}
              emailTextRef={emailTextRef}
              selectedLead={selectedLead}
              getMessages={getMessages}
              mode={scheduleMessageForm.mode}
              close={() => setscheduleMessageForm({ open: false })}
              refetch={refetchScheduledEmailsForLeadHandler}
              selectedScheduleEmail={selectedScheduleEmail}
              setselectedScheduleEmail={setselectedScheduleEmail}
              updateScheduledEmail={updateScheduledEmail}
            />
          ) : (
            <ScheduleMessagesPopup
              messageData={{
                message: textMode === 0 ? text?.current?.value : richTextValue,
                taskSendDatetime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
              }}
              close={() => setscheduleMessageForm({ open: false })}
              mode="ADD"
              scheduledMessages={scheduledMessages}
              selectedLead={selectedLead}
              getMessages={getMessages}
              setmessageText={setmessageText}
              reset={() => {
                const resetText = () => {
                  text.current.value = "";
                };
                if (textMode === 0) {
                  resetText();
                } else {
                  setrichTextValue("");
                }
              }}
            />
          )}
        </Modal>
        <Drawer
          open={scheduleEmailDrawer.visible}
          width="50%"
          title="Scheduled Emails"
          onClose={() => setscheduleEmailDrawer({ visible: false, emails: [] })}
        >
          <ScheduledJSX
            handleEdit={email => {
              setselectedScheduleEmail(email);
              emailTextRef.current.innerHTML = email.body;
              emailForm.setFieldsValue({ to: email.to });
              emailForm.setFieldsValue({ subject: email.subject });
              setscheduleEmailDrawer({ visible: false, emails: [] });
            }}
            emails={scheduleEmailDrawer.emails}
            showBody
            showHeader={false}
          />
        </Drawer>
        {vdpDrawerOpen && (
          <VehicleDetailPage
            open={vdpDrawerOpen}
            onClose={() => setVdpDrawerOpen(false)}
            text={text}
            setmessageText={setmessageText}
            handleInsertLink={handleInsertLink}
          />
        )}
        {ottoVinDrawerOpen && (
          <OttoVinPanel
            open={ottoVinDrawerOpen}
            onClose={() => setOttoVinDrawerOpen(false)}
            text={text}
            setmessageText={setmessageText}
            handleInsertLink={handleInsertLink}
            selectedLead={selectedLead}
            selectedOppTypeId={selectedOppTypeId}
          />
        )}
      </div>
    </Spin>
  );
}
export function Actions({ item, hover, buttonDisabled, ErrorPopover }) {
  const [tooltipVisible, settooltipVisible] = useState(false);
  const tooltipRef = useRef(null);
  // Prepare shared hover styles
  const isHoverable = hover !== false; // Treat undefined as true

  return item?.render ? (
    <Popover
      trigger="click"
      content={
        <span onClick={() => !item?.autoCloseDisabled && tooltipRef.current.click()}>
          {buttonDisabled() ? ErrorPopover : item.render}
        </span>
      }
    >
      <Tooltip open={tooltipVisible} title={item.title}>
        <span
          className={`flex-row-centered p-1 items-center justify-center ${
            hover && "hover:bg-[#E2E8F0] cursor-pointer"
          } rounded-[4px]`}
          onMouseEnter={() => hover && settooltipVisible(true)}
          onMouseLeave={() => settooltipVisible(false)}
          onClick={() => settooltipVisible(false)}
          ref={tooltipRef}
        >
          {item.icon}
        </span>
      </Tooltip>
    </Popover>
  ) : (
    <Tooltip open={tooltipVisible} title={item.title}>
      <span
        className={`flex-row-centered p-1 items-center justify-center rounded-[4px] ${
          isHoverable ? "hover:bg-[#E2E8F0] !cursor-pointer transition-colors duration-150" : ""
        }`}
        onMouseEnter={() => hover && settooltipVisible(true)}
        onMouseLeave={() => settooltipVisible(false)}
        onClick={() => settooltipVisible(false)}
        ref={tooltipRef}
      >
        {item.icon}
      </span>
    </Tooltip>
  );
}
export const EmailSchedule = ({
  popoverRef,
  emailForm,
  emailTextRef,
  selectedLead,
  getMessages,
  mode = "ADD",
  close,
  refetch,
  selectedScheduleEmail,
  updateScheduledEmail,
  setselectedScheduleEmail,
}) => {
  const [scheduleForm] = Form.useForm();
  const [createScheduledEmail, { loading: createScheduledEmailLoader }] =
    useMutation(CREATE_SCHEDULED_EMAIL);
  const handleSchedule = async values => {
    const timeComponents = dayjs(values.time);
    const hours = timeComponents.hour();
    const minutes = timeComponents.minute();
    const seconds = timeComponents.second();
    const milliseconds = timeComponents.millisecond();
    const timeStamp = dayjs(values.date)
      .hour(hours)
      .minute(minutes)
      .second(seconds)
      .millisecond(milliseconds)
      .toISOString();

    if (isEmpty(emailForm.getFieldValue("subject")) || emailTextRef.current.innerHTML === "") {
      return message.error("Please enter the subject and body of the email");
    }
    const payload = {
      scheduledDate: timeStamp,
      timezone: values.timezone,
      subject: emailForm.getFieldValue("subject"),
      body: emailTextRef.current.innerHTML,
      leadId: selectedLead.id,
      to: emailForm.getFieldValue("to"),
      id: selectedScheduleEmail?.id,
    };
    // console.log("===> EmailSchedule:payload", payload);
    if (selectedScheduleEmail?.id) {
      const scheduleEmailRes = await updateScheduledEmail({
        variables: payload,
      });
      if (scheduleEmailRes.data.updateScheduledEmail.statusCode === 200) {
        message.success(scheduleEmailRes.data.updateScheduledEmail.message);
        emailForm.resetFields();
        emailTextRef.current.innerHTML = "";
        setselectedScheduleEmail(null);
        getMessages();
      } else {
        message.error(scheduleEmailRes.data.updateScheduledEmail.message);
      }
    } else {
      const res = await createScheduledEmail({
        variables: payload,
      });
      if (res.data.createScheduledEmail.statusCode === 200) {
        message.success(res.data.createScheduledEmail.message);
        emailForm.resetFields();
        scheduleForm.resetFields();
        emailTextRef.current.innerHTML = "";
        getMessages();
        refetch();
        close();
      } else {
        message.error(res.data.createScheduledEmail.message);
      }
    }
  };

  return (
    <Form layout="vertical" form={scheduleForm} onFinish={handleSchedule}>
      <div className="flex-col-centered gap-2 -m-3">
        <div className="flex-row-centered p-3 gap-1">
          <Form.Item
            rules={[{ required: true, message: "Please select the date" }]}
            label="Date"
            className="w-full"
            name="date"
          >
            <DatePicker className="w-full" name="date" />
          </Form.Item>
          <Form.Item
            label="Time"
            className="w-full"
            rules={[{ required: true, message: "Please select the time" }]}
            name="time"
          >
            <TimePicker name="time" className="w-full" />
          </Form.Item>
        </div>
        <div className="p-3">
          <Form.Item
            rules={[{ required: true, message: "Please select the timezone" }]}
            name="timezone"
            label="Timezone"
          >
            <Select
              name="timezone"
              options={timezones.map(timezone => ({
                label: timezone.label,
                value: timezone.value,
              }))}
            />
          </Form.Item>
        </div>
        <div className="p-3 flex-row-centered gap-1 bg-grey-100">
          <Button
            onClick={() => {
              scheduleForm.resetFields();
              close();
            }}
          >
            Cancel
          </Button>
          <Button type="primary" loading={createScheduledEmailLoader} htmlType="submit">
            Schedule
          </Button>
        </div>
      </div>
    </Form>
  );
};
